import type { RouteRecordRaw } from "vue-router";

export const companyRoutes: RouteRecordRaw[] = [
  {
    path: "/schule",
    name: "company-index",
    component: () => import("./CompanyListPage.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/schule/:companyId/groups/:groupId",
    name: "company-group-overview",
    component: () =>
      import("./[companyId]/groups/[groupId]/CompanyGroupDetailPage.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/schule/:companyId/groups/:groupId/admin_evaluations",
    name: "company-group-admin-evaluations",
    component: () =>
      import("./[companyId]/groups/[groupId]/admin_evaluations.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/schule/:companyId/groups/:groupId/admin_info",
    name: "company-group-admin-info",
    component: () => import("./[companyId]/groups/[groupId]/admin_info.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/schule/:companyId/groups/:groupId/admin_legals",
    name: "company-group-admin-legals",
    component: () => import("./[companyId]/groups/[groupId]/admin_legals.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/schule/:companyId/groups/:groupId/admin_memberships",
    name: "company-group-admin-memberships",
    component: () =>
      import("./[companyId]/groups/[groupId]/admin_memberships.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/schule/:companyId/groups/:groupId/admin_reports",
    name: "company-group-admin-reports",
    component: () => import("./[companyId]/groups/[groupId]/admin_reports.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/schule/:companyId/groups/:groupId/certificates",
    name: "company-group-certificates",
    component: () => import("./[companyId]/groups/[groupId]/certificates.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/schule/:companyId/groups/:groupId/workshops",
    name: "company-group-workshops",
    component: () => import("./[companyId]/groups/[groupId]/workshops.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/schule/:companyId/groups/:groupId/material",
    name: "company-group-material",
    component: () =>
      import("./[companyId]/groups/[groupId]/material/CompanyGroupMaterialPage.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/schule/:companyId/groups/:groupId/material/new",
    name: "company-group-material-new",
    component: () => import("./[companyId]/groups/[groupId]/material/new.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/schule/:companyId/groups/:groupId/material/edit",
    name: "company-group-material-edit",
    component: () => import("./[companyId]/groups/[groupId]/material/edit.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];
